"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _addDays = _interopRequireDefault(require("date-fns/addDays"));
var _isValid = _interopRequireDefault(require("date-fns/isValid"));
var _parseISO = _interopRequireDefault(require("date-fns/parseISO"));
var _localization = require("@lt/localization");
var _date = require("../../utils/date");
var _InstantConfirm = _interopRequireDefault(require("../../icons-react/userflow/InstantConfirm"));
var _Plane = _interopRequireDefault(require("../../icons-react/userflow/Plane"));
var _Moon = _interopRequireDefault(require("../../icons-react/userflow/Moon"));
var _CurrencyFormat = _interopRequireDefault(require("../CurrencyFormat"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SuggestedItem = function SuggestedItem(_ref) {
  var price = _ref.price,
    currencyCode = _ref.currencyCode,
    nightsCount = _ref.nightsCount,
    departureDate = _ref.departureDate,
    instantConfirm = _ref.instantConfirm,
    href = _ref.href;
  var dateAsDate = (0, _parseISO["default"])(departureDate);
  var startDate = (0, _isValid["default"])(dateAsDate) ? (0, _date.formatDate)(dateAsDate, 'd MMM') : departureDate;
  var endDate = (0, _addDays["default"])(new Date(departureDate), nightsCount);
  var convertEndDate = (0, _isValid["default"])(endDate) ? (0, _date.formatDate)(endDate, 'd MMM') : endDate;
  return /*#__PURE__*/_react["default"].createElement(StyledSuggestedItemLink, {
    href: href,
    target: "_blank"
  }, /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(StyledPrice, {
    value: price,
    currencyCode: currencyCode,
    prefix: instantConfirm ? /*#__PURE__*/_react["default"].createElement(StyledInstantConfirmIcon, null) : null
  })), /*#__PURE__*/_react["default"].createElement(Row, null, (0, _date.getDateRange)(startDate, convertEndDate, nightsCount), /*#__PURE__*/_react["default"].createElement(StyledMoonIcon, null)));
};
var HotelCardSuggestedDates = function HotelCardSuggestedDates(_ref2) {
  var items = _ref2.items,
    className = _ref2.className,
    isHotelOnly = _ref2.isHotelOnly;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  if (!items.length) {
    return null;
  }
  var offerType = isHotelOnly ? 'предложения' : 'туры';
  return /*#__PURE__*/_react["default"].createElement(StyledHotelCardSuggetedDates, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledTitle, null, t('hotelcard.dates.title', {
    offerType: offerType
  })), /*#__PURE__*/_react["default"].createElement(StyledItemsContainer, {
    $itemsCount: items.length
  }, items.map(function (item, idx) {
    return /*#__PURE__*/_react["default"].createElement(SuggestedItem, (0, _extends2["default"])({
      key: idx
    }, item));
  })));
};
var StyledMoonIcon = (0, _styledComponents["default"])(_Moon["default"]).withConfig({
  displayName: "HotelCardSuggestedDates__StyledMoonIcon",
  componentId: "sc-jk5wk-0"
})(["margin-left:2px;margin-right:2px;width:10px;height:10px;path{fill:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.blackLight;
});
var StyledTitle = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardSuggestedDates__StyledTitle",
  componentId: "sc-jk5wk-1"
})(["font-size:12px;line-height:16px;color:", ";margin-bottom:6px;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.greyLight;
});
var Row = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardSuggestedDates__Row",
  componentId: "sc-jk5wk-2"
})(["display:flex;white-space:nowrap;height:16px;align-items:center;"]);
var StyledPrice = (0, _styledComponents["default"])(_CurrencyFormat["default"]).withConfig({
  displayName: "HotelCardSuggestedDates__StyledPrice",
  componentId: "sc-jk5wk-3"
})(["font-size:16px;line-height:20px;display:flex;align-items:center;color:", ";font-weight:500;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.blackBase;
});
var StyledPricePerNight = (0, _styledComponents["default"])(_CurrencyFormat["default"]).withConfig({
  displayName: "HotelCardSuggestedDates__StyledPricePerNight",
  componentId: "sc-jk5wk-4"
})(["display:block;color:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.blackLight;
});
var StyledPlaneIcon = (0, _styledComponents["default"])(_Plane["default"]).withConfig({
  displayName: "HotelCardSuggestedDates__StyledPlaneIcon",
  componentId: "sc-jk5wk-5"
})(["width:14px;height:14px;margin-left:2px;margin-right:2px;"]);
var StyledSuggestedItemLink = _styledComponents["default"].a.withConfig({
  displayName: "HotelCardSuggestedDates__StyledSuggestedItemLink",
  componentId: "sc-jk5wk-6"
})(["text-decoration:none;position:relative;color:", ";&:hover{cursor:pointer;color:", ";", ",", "{color:", ";}", " path{stroke:", ";}", " path{fill:", ";}}&:not(:first-child){padding-left:8px;&::before{position:absolute;left:0;top:3px;content:'';width:1px;height:30px;background:", ";}}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.blackLight;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.blue;
}, StyledPrice, StyledPricePerNight, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.blue;
}, StyledPlaneIcon, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.blue;
}, StyledMoonIcon, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.blue;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.lightGrey;
});
var StyledItemsContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardSuggestedDates__StyledItemsContainer",
  componentId: "sc-jk5wk-7"
})(["display:flex;", "{width:calc(100% / ", ");}"], StyledSuggestedItemLink, function (_ref13) {
  var $itemsCount = _ref13.$itemsCount;
  return $itemsCount;
});
var StyledInstantConfirmIcon = (0, _styledComponents["default"])(_InstantConfirm["default"]).withConfig({
  displayName: "HotelCardSuggestedDates__StyledInstantConfirmIcon",
  componentId: "sc-jk5wk-8"
})(["height:16px;margin-top:1px;margin-left:-3px;"]);
var StyledHotelCardSuggetedDates = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardSuggestedDates__StyledHotelCardSuggetedDates",
  componentId: "sc-jk5wk-9"
})(["font-size:12px;padding:8px;padding-top:4px;", ";"], function (_ref14) {
  var theme = _ref14.theme;
  return (0, _styledComponents.css)(["background:", ";border-radius:", ";"], theme.colors.beige, theme.shape.borderRadiusBig);
});
var _default = exports["default"] = HotelCardSuggestedDates;